module.exports = __webpack_public_path__ + "img/Jump Casting61.8578087a.jpg";